import fetch from '../utils/fetch';

// 工作台任务提醒
export function getTaskReminderMsg(projectFid) {
  return fetch({
    method: 'GET',
    url: 'workbench/taskreminder',
    params:{
      projectFid
    }
  })
}
//查询回访列表
export function getList(params) {
  return fetch({
    method:'POST',
    url:'workbench/getPersonVisitLogList',
    data:params
  })
}
//处理回访
export function handleVisit(params) {
  return fetch({
    method:'POST',
    url:'workbench/handlePersonVisitLog',
    data:params
  })
}

//生日列表
export function birthdayList(params) {
  return fetch({
    method:'POST',
    url:'workbench/birthdayRemind',
    data:params
  })
}

export function customerTotalCount(projectFid) {
  return fetch({
    method: 'GET',
    url: 'workbench/getVisitAndBirthdayTotal',
    params:{
      projectFid
    }
  })
}

//获取回访状态
export function getVisitStatus() {
  return fetch({
    method: 'GET',
    url: 'workbench/visitStatus'
  })
}

//获取销售看板数量数据
export function querySaleKanBanCount(params) {
  return fetch({
    method:'POST',
    url:'workbench/querySaleKanBanCount',
    data:params
  })
}

//获取销售看板入住率，跟进率
export function queryFlowRateAndCheckInRate(params) {
  return fetch({
    method:'POST',
    url:'workbench/queryFlowRateAndCheckInRate',
    data:params
  })
}

//获取销售看板接听率
export function queryAnswerRate(params) {
  return fetch({
    method:'POST',
    url:'workbench/queryAnswerRate',
    data:params
  })
}

// 工作台续约意向跟进根据父合同id查询子合同数量
export function findChildContractCountByParentFid(params) {
  return fetch({
    method:'GET',
    url:'workbench/findChildContractCountByParentFid',
    params
  })
}

// 工作台水电表数列表
export function getWaterReadList(params) {
  return fetch({
      method:'GET',
      url:'waterwatt/ordinary/reading/list',
      params
  })
}

// 抄表记录水电类型
export function getMeterTypeList() {
  return fetch({
    method: 'GET',
    url: 'waterwatt/getMeterTypeList'
  })
}

// 处理表数 录入
export function waterwattSave(data) {
  return fetch({
    method: 'POST',
    url: 'waterwatt/ordinary/reading/save',
    data
  })
}

